export const SELECTED_CYCLE_ID = 'SELECTED_CYCLE_ID'
